/**
 * Portuguese Brazilian translate
 * @type Object
 */
/* eslint camelcase: 0 */
const pt_BR = {
  btn: {
    about: 'Sobre',
    back: 'Voltar',
    cancel: 'Cancelar',
    clear: 'Limpar',
    copy: 'Copiar',
    cut: 'Recortar',
    delete: 'Apagar',
    edit: 'Editar',
    forward: 'Avançar',
    folder: 'Nova pasta',
    file: 'Novo arquivo',
    fullScreen: 'Tela cheia',
    grid: 'Grade',
    paste: 'Colar',
    refresh: 'Atualizar',
    submit: 'Criar',
    table: 'Tabela',
    upload: 'Upload',
    uploadSelect: 'Selecionar arquivos',
    hidden: ' Arquivos ocultos',
  },
  clipboard: {
    actionType: 'Formato',
    copy: 'Copiar',
    cut: 'Recortar',
    none: 'Nada selecionado',
    title: 'Área de transferência',
  },
  contextMenu: {
    copy: 'Copiar',
    cut: 'Colar',
    delete: 'Apagar',
    download: 'Download',
    info: 'Selecionado:',
    open: 'Abrir',
    paste: 'Colar',
    properties: 'Propriedades',
    rename: 'Renomear',
    select: 'Selecionar',
    view: 'Visualizar',
    zip: 'Compactar',
    unzip: 'Descompactar',
    edit: 'Editar',
    audioPlay: 'Play',
    videoPlay: 'Play',
  },
  info: {
    directories: 'Pastas:',
    files: 'Arquivos:',
    selected: 'Selecionado:',
    selectedSize: 'Tamanho dos arquivos:',
    size: 'Tamanho dos arquivos:',
  },
  manager: {
    table: {
      date: 'Data',
      folder: 'Pasta',
      name: 'Nome',
      size: 'Tamanho',
      type: 'Tipo',
    },
  },
  modal: {
    about: {
      developer: 'Desenvolvedor',
      name: 'Laravel File Manager',
      title: 'Sobre',
      version: 'Versão',
    },
    delete: {
      noSelected: 'Nada selecionado!',
      title: 'Apagar',
    },
    newFile: {
      fieldName: 'Nome do arquivo',
      fieldFeedback: 'Arquivo existente!',
      title: 'Criar novo arquivo',
    },
    newFolder: {
      fieldName: 'Nome da pasta',
      fieldFeedback: 'Pasta existente!',
      title: 'Criar nova pasta',
    },
    preview: {
      title: 'Visualizar',
    },
    properties: {
      disk: 'Disco',
      modified: 'Modificado',
      name: 'Nome',
      path: 'Caminho',
      size: 'Tamanho',
      title: 'Propriedades',
      type: 'Tipo',
      url: 'URL',
      access: 'Acesso',
      access_0: 'Acesso negado',
      access_1: 'Apenas leitura',
      access_2: 'Leitura e escrita',
    },
    rename: {
      directoryExist: 'Pasta existente',
      fieldName: 'Digite o novo nome',
      fieldFeedback: 'Nome inválido',
      fileExist: 'Arquivo existente',
      title: 'Renomear',
    },
    status: {
      noErrors: 'Nenhum erro!',
      title: 'Status',
    },
    upload: {
      ifExist: 'Se arquivo não existir:',
      noSelected: 'Nenhum arquivo selecionado!',
      overwrite: 'Substituir!',
      selected: 'Selecionado:',
      size: 'Tamanho:',
      skip: 'Pular',
      title: 'Upload de arquivos',
    },
    editor: {
      title: 'Editor',
    },
    audioPlayer: {
      title: 'Áudio player',
    },
    videoPlayer: {
      title: 'Video player',
    },
    zip: {
      title: 'Compactar arquivo',
      fieldName: 'Nome do arquivo',
      fieldFeedback: 'Arquivo existente!',
    },
    unzip: {
      title: 'Descompactar arquivo',
      fieldName: 'Nome da pasta',
      fieldRadioName: 'Extrair para:',
      fieldRadio1: 'Pasta atual',
      fieldRadio2: 'Nova pasta',
      fieldFeedback: 'Pasta existente!',
      warning: 'Atenção! Se os nomes forem idênticos, os arquivos serão substituídos!',
    },
    cropper: {
      title: 'Cortar',
      apply: 'Aplicar',
      reset: 'Resetar',
      save: 'Salvar',
    },
  },
  notifications: {
    cutToClipboard: 'Recortado para área de transferência!',
    copyToClipboard: 'Copiado para área de transferência!',
  },
  response: {
    noConfig: 'Configuração não encontrada!',
    notFound: 'Não encontrado!',
    diskNotFound: 'Disco não encontrado!',
    pathNotFound: 'Caminho não encontrado!',
    diskSelected: 'Disco selecionado!',
    // files
    fileExist: 'Arquivo já existe!',
    fileCreated: 'Arquivo criado!',
    fileUpdated: 'Arquivo atualizado!',
    fileNotFound: 'Arquivo não encontrado!',
    // directories
    dirExist: 'Pasta já existe!',
    dirCreated: 'Pasta criada!',
    dirNotFound: 'Pasta não encontrada',
    // actions
    uploaded: 'Todos os arquivo realizarm o upload!',
    notAllUploaded: 'Alguns arquivos não realizaram o upload!',
    delNotFound: 'Alguns itens não foram encontrados!',
    deleted: 'Deletado!',
    renamed: 'Renomeado!',
    copied: 'Copiado com sucesso!',
    // zip
    zipError: 'Erro ao compactar!',
    // acl
    aclError: 'Acesso negado!',
  },
};

export default pt_BR;
